import { combineReducers } from 'redux';
import pickingZoneReducers from './pickingZoneReducers';
import shippingZoneReducers from './shippingZoneReducers';

export default combineReducers({
  pickingZone: pickingZoneReducers,
  shippingZone: shippingZoneReducers,
});
